import React from "react";
import { FilmStrip } from "@phosphor-icons/react";

export const CompletedVideosTable = ({ videos }) => (
  <div className="surface-card overflow-hidden" data-testid="completed-tab-content">
    <div className="overflow-x-auto">
      <table className="w-full">
        <thead>
          <tr className="bg-[#0B0C10] text-[#A0AEC0] text-sm uppercase tracking-wider">
            <th className="text-left p-4 font-medium">Title</th>
            <th className="text-left p-4 font-medium">Type</th>
            <th className="text-left p-4 font-medium">Editor</th>
            <th className="text-left p-4 font-medium">Completed</th>
          </tr>
        </thead>
        <tbody>
          {videos.map((video) => (
            <tr key={video.id} className="table-row">
              <td className="p-4 text-white text-sm">{video.title}</td>
              <td className="p-4 text-gray-400 text-sm">
                {video.is_short ? "Short" : "Long"}
              </td>
              <td className="p-4 text-gray-300 text-sm">
                {video.editor_name || "Unassigned"}
              </td>
              <td className="p-4 text-gray-400 text-sm">
                {video.completed_at
                  ? new Date(video.completed_at).toLocaleDateString()
                  : "-"}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
    {videos.length === 0 && (
      <div className="text-center py-12">
        <FilmStrip size={48} className="text-gray-600 mx-auto mb-4" />
        <p className="text-gray-400">No completed videos yet</p>
      </div>
    )}
  </div>
);
